var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VsWrapper,[_c(_setup.VsTextInput,{attrs:{"data-test":"number-field","input-class":"text-left","type":"number","label":_vm.title,"hint":_setup.props.description ?? '',"value":_vm.formData,"error-messages":_setup.errorMessages,"disabled":_setup.props.disabled},on:{"input":_setup.handleInputChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }